import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
// import { ToastrService } from 'ngx-toastr';
import { PreferencesService } from 'src/app/services/preferences.service';

@Component({
  selector: 'app-interest-edit',
  templateUrl: './interest-edit.component.html',
  styleUrls: ['./interest-edit.component.css']
})
export class InterestEditComponent implements OnInit {

  interesteditForm!:FormGroup;
  submitted: any;
  token: any;
  incomeData: any;
  id:any;
  image:any
  imageSrc:any
  fileName!: string;

  constructor(public router: Router,
    private prefrencesService: PreferencesService,
    private toastr : ToastrService,
    private activateroute: ActivatedRoute,
    private formBuilder : FormBuilder
    ) { }

  ngOnInit(): void {
    this.id = this.activateroute.snapshot.paramMap.get('id');
    this.interesteditForm = this.formBuilder.group({
      name: ['',[Validators.required,this.prefrencesService.noSpacesValidator]],
      image:['']
    });
    this.geteditData()
  }

  get editForm() {return this.interesteditForm.controls;}

  onImageSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.image = file;
      this.fileName =  file.name
      this.createImagePreview(file);
    }
  }

  createImagePreview(file: File) {
    const reader = new FileReader();
    reader.onload = (event: any) => {
      this.imageSrc = event.target.result;
    };
    reader.readAsDataURL(file);
  }

  geteditData(){
    let obj = {
      id : this.id
    };
    this.token = localStorage['token'];
    this.prefrencesService.interestDetail(obj, this.token).subscribe((res: any) => {
      if (res && res.status == 200) {
        this.incomeData = res.data;
        console.log(this.incomeData)
        this.interesteditForm.patchValue({
          name:this.incomeData.name,
        });
        const imageName=this.incomeData.image.split('/')
        this.fileName=imageName[imageName?.length - 1]
        this.image = this.incomeData.image;
        this.interesteditForm.value.image = this.image;
        if (this.image) {
          this.imageSrc = this.image;  // Assuming image is a URL or base64 data
        }
        // this.toastr.success(res.message);
      }
      else{
        // this.toastr.success(res.message);
        alert(res.message);
      }
    });
  }

  onSubmit(){
    this.submitted = true;
    if (this.interesteditForm.invalid) {
      return;
    }
    this.token = localStorage['token'];
    let formData = new FormData()
    formData.append('name',this.interesteditForm.get('name')?.value)
    formData.append('image',this.image)
    formData.append('id',this.id)
    this.prefrencesService.interestUpdate(formData,this.token).subscribe((res: any) => {
      if (res && res.status == 200) {
        this.toastr.success(res.message);
        this.router.navigate(['/interest']);
        this.interesteditForm.reset();
        this.submitted = false;
      }
    });
  }

}
